import { auth, widgetChatStreamUrl } from "./firebase/firebase";

/**
 * POST to widgetChatStream and parse SSE events.
 * @param {{ chatbotId: string, text: string, parentUrl?: string, clientMessageId?: string }} params
 * @param {{ onMeta?: Function, onToken?: Function, onDone?: Function, onError?: Function }} handlers
 */
export async function streamWidgetChat(
	{ chatbotId, text, parentUrl, clientMessageId },
	{ onMeta, onToken, onDone, onError } = {}
) {
	const user = auth.currentUser;
	if (!user) {
		throw new Error("Not authenticated");
	}
	if (!widgetChatStreamUrl) {
		throw new Error("widgetChatStream URL is not configured");
	}

	const roomId = `${user.uid}***${chatbotId}`;
	const idToken = await user.getIdToken();

	const response = await fetch(widgetChatStreamUrl, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${idToken}`,
		},
		body: JSON.stringify({
			chatbotId,
			roomId,
			text,
			parentUrl: parentUrl || document.referrer || "",
			clientMessageId: clientMessageId || undefined,
		}),
	});

	if (!response.ok) {
		let message = `Chat stream failed (${response.status})`;
		try {
			const errBody = await response.json();
			if (errBody?.error) message = errBody.error;
		} catch {
			/* ignore */
		}
		throw new Error(message);
	}

	if (!response.body) {
		throw new Error("No response body from chat stream");
	}

	const reader = response.body.getReader();
	const decoder = new TextDecoder();
	let buffer = "";

	const dispatchEvent = (eventName, dataStr) => {
		let data = {};
		try {
			data = dataStr ? JSON.parse(dataStr) : {};
		} catch {
			data = { raw: dataStr };
		}
		if (eventName === "meta" && onMeta) onMeta(data);
		else if (eventName === "token" && onToken) onToken(data);
		else if (eventName === "done" && onDone) onDone(data);
		else if (eventName === "error" && onError) onError(data);
	};

	while (true) {
		const { done, value } = await reader.read();
		if (done) break;
		buffer += decoder.decode(value, { stream: true });

		let sepIndex;
		while ((sepIndex = buffer.indexOf("\n\n")) !== -1) {
			const rawEvent = buffer.slice(0, sepIndex);
			buffer = buffer.slice(sepIndex + 2);

			let eventName = "message";
			const dataLines = [];
			for (const line of rawEvent.split("\n")) {
				if (line.startsWith("event:")) {
					eventName = line.slice(6).trim();
				} else if (line.startsWith("data:")) {
					dataLines.push(line.slice(5).trim());
				}
			}
			dispatchEvent(eventName, dataLines.join("\n"));
		}
	}
}
